import React from 'react';
import { Skeleton } from '@fourthwall/components';
import * as S from './BarChart.styled';
import { Bar } from './components/Bar/Bar';
import { getMaxValueFromBarChartData } from './utils/getMaxValueFromBarChartData';
export const BAR_DEFAULT_COLORS = ['var(--bg-brand)', 'var(--bg-quaternary)'];
export const BarChart = ({ data, formatValue, totalValue, isLoading = false, animation = true, }) => {
    if (isLoading)
        return React.createElement(BarChartSkeleton, null);
    const maxValue = totalValue || getMaxValueFromBarChartData(data);
    const renderValue = (value) => {
        if (Array.isArray(value)) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Bar, { color: BAR_DEFAULT_COLORS[0], value: value[0], maxValue: maxValue, formatValue: formatValue, animation: animation }),
                React.createElement(Bar, { color: BAR_DEFAULT_COLORS[1], value: value[1], maxValue: maxValue, formatValue: formatValue, animation: animation })));
        }
        return (React.createElement(Bar, { color: BAR_DEFAULT_COLORS[0], value: value, maxValue: maxValue, formatValue: formatValue, animation: animation }));
    };
    return (React.createElement(S.Container, null, data.map((item, index) => (React.createElement(S.Item, { key: index },
        React.createElement(S.Label, null, item.label),
        renderValue(item.value))))));
};
const BarChartSkeleton = () => (React.createElement(S.Container, null, [...Array(4)].map((_, index) => {
    const firstBarWidth = Math.max(70 - index * 15, 25);
    const secondBarWidth = Math.max(60 - index * 15, 15);
    return (React.createElement(S.Item, { key: index },
        React.createElement(S.Label, null,
            React.createElement(Skeleton.Shape, { width: 80, height: 20 })),
        React.createElement(S.BarContainer, null,
            React.createElement(Skeleton.Shape, { width: `${firstBarWidth}%`, height: 20 }),
            React.createElement(S.Value, null,
                React.createElement(Skeleton.Shape, { width: 70, height: 20 }))),
        React.createElement(S.BarContainer, null,
            React.createElement(Skeleton.Shape, { width: `${secondBarWidth}%`, height: 20 }),
            React.createElement(S.Value, null,
                React.createElement(Skeleton.Shape, { width: 70, height: 20 })))));
})));
BarChart.Bar = Bar;
